import React, { useContext, useEffect, useRef, useCallback } from "react";
import Select from "../form-input/select";
import { FormContext } from "../../dynamic-form/dynamic-form-context";
import { DataService } from "../../../../services/data-service";
import { filter, take } from "rxjs/operators";

const matchRegEx = (string, pattern) => {
  const regex = new RegExp(pattern);
  return regex.test(string);
};

export default function ReduxDropdown({ metadata }) {
  const { setFormValues, formValues } = useContext(FormContext);
  const isInitialized = useRef(false);
  const prevOptionsRef = useRef(null);

  const currentValue = formValues[metadata.name]?.value || '';
  const isValidOption = metadata.options?.some(
    (option) => Object.keys(option).includes(currentValue)
  );
  const displayValue = isValidOption
    ? currentValue
    : (metadata.options?.[0] ? Object.keys(metadata.options[0])[0] : '');

  const updatePayload = useCallback((name, value) => {
    DataService.getPayloadToRetrieveFormInfo()
      .pipe(
        filter(payload => payload !== null),
        take(1)
      )
      .subscribe((payload) => {
        const updatedPayload = { ...payload, [name]: value };
        DataService.setPayloadToRetrieveFormInfo(updatedPayload);
      });
  }, []);

  useEffect(() => {
    if (!metadata.options?.length) return;

    const optionsKey = JSON.stringify(metadata.options);
    if (prevOptionsRef.current === optionsKey) return;

    const isFirstLoad = prevOptionsRef.current === null;
    prevOptionsRef.current = optionsKey;

    const defaultValue = Object.keys(metadata.options[0])[0];

    if (isFirstLoad) {
      if (!currentValue || !isValidOption) {
        setFormValues(
          metadata.name,
          defaultValue,
          matchRegEx(defaultValue, ".+") || !metadata.required
        );
        updatePayload(metadata.name, defaultValue);
      }
    } else {
      setFormValues(
        metadata.name,
        defaultValue,
        matchRegEx(defaultValue, ".+") || !metadata.required
      );
      updatePayload(metadata.name, defaultValue);
    }

    isInitialized.current = true;
  }, [metadata.options]);
  
  useEffect(() => {
    if (
      isInitialized.current &&
      displayValue &&
      displayValue !== currentValue
    ) {
      setFormValues(
        metadata.name,
        displayValue,
        matchRegEx(displayValue, ".+") || !metadata.required
      );
    }
  }, [displayValue]);

  const handleChange = (event) => {
    const value = event.target.value;
    console.log('=== handleChange ===');
    console.log('combo:', metadata.name);
    console.log('valor nuevo:', value);
    
    DataService.getPayloadToRetrieveFormInfo()
      .pipe(filter(Boolean), take(1))
      .subscribe((payload) => {
        console.log('payload actual antes de update:', JSON.stringify(payload));
        const updatedPayload = { ...payload, [metadata.name]: value };
        console.log('payload después de update:', JSON.stringify(updatedPayload));
        DataService.setPayloadToRetrieveFormInfo(updatedPayload);
      });

    setFormValues(
      metadata.name,
      value,
      matchRegEx(value, ".+") || !metadata.required
    );
  };

  return (
    <Select
      id={metadata.name}
      metadata={metadata}
      valid={matchRegEx(displayValue, ".+") || !metadata.required}
      onChange={handleChange}
      type={"select"}
      value={displayValue}
      valueFromKey={1}
    />
  );
}